export const SITE_CONFIG = {
  name: "Name Arcane",
  shortName: "Name Arcane",
  tagline: "Every name has a spell in it",
  description:
    "The world's most comprehensive fantasy, sci-fi, character, cultural, and location name generator. Every name has a spell in it.",
  url: (process.env.NEXT_PUBLIC_SITE_URL || "https://namearcane.com").replace(/\/+$/, ""),
  email: "info@namearcane.com",
  ogImage: "/images/Logo/Dark Logo.png",
  logo: "/images/Logo/Transferent logo.png",
  logoTransparent: "/images/Logo/Transferent logo.png",
  logoLight: "/images/Logo/white Logo.png",
  logoDark: "/images/Logo/Dark Logo.png",
  favicon: "/images/Logo/favicon.ico",
  appleIcon: "/images/Logo/apple-touch-icon.png",
  twitterHandle: "@namearcane",
  author: "Paul Arcane",
  authorRole: "Creator & Worldbuilding Enthusiast",
  themeColor: "#0f172a",
  gtmId: process.env.NEXT_PUBLIC_GTM_ID || "GTM-M2KP3G35",
  keywords: [
    "name arcane",
    "paul arcane",
    "fantasy name generator",
    "character name generator",
    "dnd 5e name generator",
    "dragon names",
    "elven names",
    "wizard names",
    "kingdom names",
    "rpg name generator",
    "random name generator",
  ],
};

export const SITE_URL = SITE_CONFIG.url;
export const SITE_NAME = SITE_CONFIG.name;
